import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=42835d60"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42835d60')) {
      api.createRecord('42835d60', component.options)
    } else {
      api.reload('42835d60', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=42835d60", function () {
      api.rerender('42835d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login-page/LoginPage.vue"
export default component.exports